import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { LOGO_URL, PHONE_DISPLAY, PHONE_HREF } from '../data/content';
import { NavAccordion } from './NavAccordion';
export function Header() {
  return <header className="sticky top-0 z-40 w-full border-b border-forest-900/40 bg-forest-800" data-id="element-105" data-mp="2ikxy6g50e23x">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3" data-id="element-106" data-mp="2nkafymh0wizn">
        <div className="flex min-w-0 items-center gap-3" data-id="element-107" data-mp="2rmf8tizndbl8">
          <img src={LOGO_URL} alt="Javier's Junk Removal" className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14" data-id="element-108" data-mp="2rlvra3dwsp7q" />
          <div className="min-w-0 leading-tight" data-id="element-109" data-mp="2wivy4gil1vzw">
            <p className="whitespace-nowrap font-display text-base uppercase tracking-tight text-white sm:text-xl sm:tracking-wide" data-id="element-110" data-mp="31d08l9r24m5q">
              Javier&apos;s Junk Removal
            </p>
            <p className="hidden truncate whitespace-nowrap text-xs font-medium text-forest-100 sm:block" data-id="element-111" data-mp="3baxv9st9qaw8">
              North County&apos;s Local Junk Removal Solution
            </p>
          </div>
        </div>

        <a href={PHONE_HREF} aria-label={`Call Javier's Junk Removal for a free quote at ${PHONE_DISPLAY}`} className="group flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-md bg-ember-500 px-4 py-2.5 text-ink-900 transition-colors duration-150 ease-out hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-forest-800 sm:px-5" data-id="element-112" data-mp="2wlm739qzpwhs">
          <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-113" data-mp="3fdf197hspnr3" />
          <span className="flex flex-col items-start leading-none" data-id="element-114" data-mp="3adk9l1q74u4z">
            <span className="hidden text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-900/70 sm:block" data-id="element-115" data-mp="35l0we5vf810p">
              Free quote
            </span>
            <span className="font-display text-base uppercase tracking-wide sm:mt-0.5 sm:text-lg" data-id="element-116" data-mp="30kd83ryktya6">
              <span className="hidden sm:inline" data-id="element-117" data-mp="1yire5gujuhw">{PHONE_DISPLAY}</span>
              <span className="sm:hidden" data-id="element-118" data-mp="3tabt9c9nhb9k">Call now</span>
            </span>
          </span>
        </a>
      </div>

      <NavAccordion data-id="element-119" data-mp="1recxdmd3v5n5" />
    </header>;
}